module.exports = __webpack_public_path__ + "img/parpar_no.dcff9b94.png";